export const fills = [
  '#3f5efb',
  '#a650ab',
  '#8854c2',
  '#b34fa2',
  '#cc4c8f',
  '#fc466b',
]

// export const fills2 = [
//   '#3E5DF7',
//   '#6958d8',
//   '#8854c2',
//   '#b34fa2',
//   '#cc4c8f',
//   '#B34EA0',
// ]

export const fills2 = [
  '#3c5bf1',
  '#7559ec',
  '#9957e5',
  '#b556de',
  '#cc56d6',
  '#e058ce',
  '#f15dc5',
  '#ff63bd',
]
